export const SUBRUBRIC_PICKER_CONSTS = {
  subrubricMsg: 'Подрубрика',
  withoutSubricMsg: 'Без подрубрики'
}
